import { getFetcher } from "@/services/global";
import { useState } from "react";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";

const useProductShowReviews = (url) => {
  const [data, setData] = useState({});
  const { isValidating } = useSWR(`${url}`, getFetcher, {
    revalidateOnFocus: false,
    onSuccess: (data) => {
      setData(data);
    },
  });

  const { trigger: fetchMoreReviews } = useSWRMutation(
    `${data?.next_page_url}`,
    getFetcher,
    {
      onSuccess: (data) => {
        setData((prev) => ({
          reviews: [...prev?.reviews, ...data?.reviews],
          next_page_url: data?.next_page_url || "",
        }));
      },
    }
  );

  const showMoreHandler = () => {
    fetchMoreReviews();
  };
  return { isLoading: isValidating, data, showMoreHandler };
};

export default useProductShowReviews;
